import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import OnlineList from "./VOnlieList";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

class Online extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact component={OnlineList} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Online);
